var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommentsGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_976_9067)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5007 22.0423C11.2465 22.0423 11.0027 21.9414 10.823 21.7616C10.6433 21.5819 10.5423 21.3382 10.5423 21.084V18.209H6.70898C6.20065 18.209 5.71314 18.0071 5.3537 17.6476C4.99425 17.2882 4.79232 16.8006 4.79232 16.2923V6.70898C4.79232 6.20065 4.99425 5.71314 5.3537 5.3537C5.71314 4.99425 6.20065 4.79232 6.70898 4.79232H20.1257C20.634 4.79232 21.1215 4.99425 21.4809 5.3537C21.8404 5.71314 22.0423 6.20065 22.0423 6.70898V16.2923C22.0423 16.8006 21.8404 17.2882 21.4809 17.6476C21.1215 18.0071 20.634 18.209 20.1257 18.209H16.1965L12.6507 21.7644C12.459 21.9369 12.229 22.0423 11.9798 22.0423H11.5007ZM2.87565 14.3757H0.958984V2.87565C0.958984 2.36732 1.16092 1.87981 1.52036 1.52036C1.87981 1.16092 2.36732 0.958984 2.87565 0.958984H18.209V2.87565H2.87565V14.3757Z",
    fill: "#51CDA0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_976_9067"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentsGreen);
export default __webpack_public_path__ + "static/media/commentsGreen.19205fb8693922ba0ccced37cb968789.svg";
export { ForwardRef as ReactComponent };